<template>
  <v-container fluid pa-0 grid-list-lg class="bm-4col-plain">
    <v-layout wrap>
      <slot />
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmFieldList",
});
</script>

<style scoped lang="sass">
.bm-4col-plain
  margin-bottom: 20px
</style>
